/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {Money} from "./money.zod";

export const chapterPricingCoefficientExclusiveMin = 0;

export const chapterPricingCommissionFractionMin = 0;
export const chapterPricingCommissionFractionMax = 1;

export const ChapterPricing = zod
  .object({
    coefficient: zod.number().gt(chapterPricingCoefficientExclusiveMin).optional(),
    commissionFraction: zod
      .number()
      .min(chapterPricingCommissionFractionMin)
      .max(chapterPricingCommissionFractionMax)
      .optional(),
    chapterSum: Money.optional(),
    costWithBenefit: Money.optional(),
    commissionAmount: Money.optional(),
    total: Money.optional(),
    salePrice: Money.optional(),
    benefitValue: Money.optional(),
  })
  .describe(
    "Field presence follows the owning Chapter's individual availability fields. Coefficient is independently protected, including for unprotected costs. total is calculated before commercial rounding; salePrice is final selling rounded upward to 100 major Currency units. benefitValue includes that uplift.",
  );

export type ChapterPricing = zod.input<typeof ChapterPricing>;
export type ChapterPricingOutput = zod.output<typeof ChapterPricing>;
